export default[
    {
        symbol: "",
        name: "私搭乱建",
        pointType: "point",
        belong: "城管局",
        pointColor: "rgba(217, 0, 27, 1)", // 球颜色
        lineStyle: {
          color: 'red', // 线颜色
        },
        effect: {
          period: 2, // 箭头快慢
          symbolSize: [6, 20], // 箭头大小
        },
      },  
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"乱搭乱建"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"违法焚烧垃圾"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"临街阳台脏乱差"
}
,
{
symbol:"",
pointType: "point",
belong:"区城管局",
name:"高架挂箱滴水"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"道路积泥"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"道路破损"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"污水横流"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"店面无证装修"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"建筑物外立面不洁"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"乱倒乱排污水、废水"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"人行道板破损"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"侵占公共用地"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"废弃车辆"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"沿街晾晒"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"遮阳篷破损"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"空调室外机滴水、低挂"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"非装饰性吊挂物"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"非法小广告"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"违规标语宣传品"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"违规牌匾标识"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"街头散发小广告"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"广告语言文字不规范"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"违规户外广告"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"广告破损"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"工地物料乱堆放"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"违章建筑"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"工地扬尘"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"施工废弃料"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"施工占道"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"施工扰民"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"施工工地围挡"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"施工工地道路未硬化"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"施工完成后未场光地净"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"施工工地车轮夹带"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"路面塌陷"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"下水道堵塞"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"化粪池满溢"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"污水管满溢"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"低洼积水"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"占道废品收购"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"出店经营"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"乱堆物堆料"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"违法占道经营"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"施放系留气球"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"非机动车乱停放"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"污水井盖"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"中水井盖"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"雨水井盖"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"雨水篦子"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"污水沟"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"违法接管排水"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"其他部件"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"路灯井盖"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"路灯破损、缺亮、缺失"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"地灯破损、缺亮、缺失"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"景观灯破损、缺亮、缺失"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"街头座椅破损、脱落、缺失"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"喷泉破损、缺失、倾斜"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"防撞桶破损、脱落、缺失"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"雕塑破损、缺失、倾斜"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"沿街立面脏、缺、损"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"违章接坡"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"违章挖掘"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"景观亭子"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"桥梁"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"积存垃圾渣土"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"渣土乱倒"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"工地出入口不洁"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"抛洒滴漏"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"垃圾漫溢"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"暴露垃圾"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"废弃家具"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"路面不洁"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"环卫车辆抛洒滴漏"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"公厕管理"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"化粪池井盖"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"沟槽厕所盖板"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"公厕指示牌"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"垃圾间（楼）"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"垃圾箱破损、倾斜"
}
,
{
symbol:"",
pointType:"point",
belong:"区城管局",
name:"垃圾车不洁"
}
,
{
symbol:"",
pointType:"point",
belong:"区交警大队",
name:"信号灯电源井盖"
}
,
{
symbol:"",
pointType:"point",
belong:"区交警大队",
name:"停车场"
}
,
{
symbol:"",
pointType:"point",
belong:"区交警大队",
name:"交通护栏"
}
,
{
symbol:"",
pointType:"point",
belong:"区交警大队",
name:"街面秩序"
}
,
{
symbol:"",
pointType:"point",
belong:"区交警大队",
name:"其他设施"
}
,
{
symbol:"",
pointType:"point",
belong:"区供电局",
name:"电力井盖"
}
,
{
symbol:"",
pointType:"point",
belong:"区供电局",
name:"电缆井盖"
}
,
{
symbol:"",
pointType:"point",
belong:"区供电局",
name:"电力设施"
}
,
{
symbol:"",
pointType:"point",
belong:"区供电局",
name:"电力设施标识牌"
}
,
{
symbol:"",
pointType:"point",
belong:"区供电局",
name:"电力立杆"
}
,
{
symbol:"",
pointType:"point",
belong:"区供电局",
name:"高压线铁塔"
}
,
{
symbol:"",
pointType:"point",
belong:"区供电局",
name:"变压器（箱）"
}
,
{
symbol:"",
pointType:"point",
belong:"区公安局",
name:"公安井盖"
}
,
{
symbol:"",
pointType:"point",
belong:"区公安局",
name:"公共安全事件"
}
,
{
symbol:"",
pointType:"point",
belong:"区市场监督局",
name:"经营管理"
}
,
{
symbol:"",
pointType:"point",
belong:"区市场监督局",
name:"公共安全事件"
}
,
{
symbol:"",
pointType:"point",
belong:"区市场监督局",
name:"无证经营"
}
,
{
symbol:"",
pointType:"point",
belong:"区市场监督局",
name:"市场管理"
}
,
{
symbol:"",
pointType:"point",
belong:"区市场监督局",
name:"食品安全"
}
,
{
symbol:"",
pointType:"point",
belong:"区市场监督局",
name:"生产安全"
}
,
{
symbol:"",
pointType:"point",
belong:"区市场监督局",
name:"特种设备"
}
,
{
symbol:"",
pointType:"point",
belong:"区住建局",
name:"施工管理（工地）"
}
,
{
symbol:"",
pointType:"point",
belong:"区住建局",
name:"房屋建设（房屋内部）"
}
,
{
symbol:"",
pointType:"point",
belong:"区自来水公司",
name:"自来水管破裂"
}
,
{
symbol:"",
pointType:"point",
belong:"区自来水公司",
name:"上水井盖"
}
,
{
symbol:"",
pointType:"point",
belong:"区自来水公司",
name:"水井"
}
,
{
symbol:"",
pointType:"point",
belong:"移动公司",
name:"通信井盖"
}
,
{
symbol:"",
pointType:"point",
belong:"移动公司",
name:"通信交接箱"
}
,
{
symbol:"",
pointType:"point",
belong:"移动公司",
name:"通信立杆"
}
,
{
symbol:"",
pointType:"point",
belong:"移动公司",
name:"电话亭"
}
,
{
symbol:"",
pointType:"point",
belong:"移动公司",
name:"通信设施"
}
,
{
symbol:"",
pointType:"point",
belong:"电信公司",
name:"通信井盖"
}
,
{
symbol:"",
pointType:"point",
belong:"电信公司",
name:"通信交接箱"
}
,
{
symbol:"",
pointType:"point",
belong:"电信公司",
name:"通信立杆"
}
,
{
symbol:"",
pointType:"point",
belong:"电信公司",
name:"电话亭"
}
,
{
symbol:"",
pointType:"point",
belong:"电信公司",
name:"通信设施"
}
,
{
symbol:"",
pointType:"point",
belong:"联通公司",
name:"通信井盖"
}
,
{
symbol:"",
pointType:"point",
belong:"联通公司",
name:"通信交接箱"
}
,
{
symbol:"",
pointType:"point",
belong:"联通公司",
name:"通信立杆"
}
,
{
symbol:"",
pointType:"point",
belong:"联通公司",
name:"电话亭"
}
,
{
symbol:"",
pointType:"point",
belong:"联通公司",
name:"通信设施"
}
,
{
symbol:"",
pointType:"point",
belong:"区燃气公司",
name:"燃气管道破裂"
}
,
{
symbol:"",
pointType:"point",
belong:"区燃气公司",
name:"其他"
}
,
{
symbol:"",
pointType:"point",
belong:"区人社局",
name:"劳动仲裁"
}
,
{
symbol:"",
pointType:"point",
belong:"区人社局",
name:"社会保障（工伤）"
}
,
{
symbol:"",
pointType:"point",
belong:"区人社局",
name:"劳动监察"
}
,
{
symbol:"",
pointType:"point",
belong:"区人社局",
name:"其他"
}
,
{
symbol:"",
pointType:"point",
belong:"区园林局",
name:"花、草、苗、木破损"
}
,
{
symbol:"",
pointType:"point",
belong:"区园林局",
name:"绿化带破损、损坏"
}
,
{
symbol:"",
pointType:"point",
belong:"区园林局",
name:"树木病虫害无人防治"
}
,
{
symbol:"",
pointType:"point",
belong:"区园林局",
name:"树木无人修剪"
}
,
{
symbol:"",
pointType:"point",
belong:"区林业局",
name:"古树名木"
}
,
{
symbol:"",
pointType:"point",
belong:"区林业局",
name:"护树设施"
}
,
{
symbol:"",
pointType:"point",
belong:"区林业局",
name:"违法砍伐"
}
,
{
symbol:"",
pointType:"point",
belong:"区林业局",
name:"猎杀售卖被保护动物"
}
,
{
symbol:"",
pointType:"point",
belong:"区林业局",
name:"故意破坏受保护植被"
}
,
{
symbol:"",
pointType:"point",
belong:"区教体局",
name:"体育健身设施"
}
,
{
symbol:"",
pointType:"point",
belong:"区教体局",
name:""
}
,
{
symbol:"",
pointType:"point",
belong:"区水利局",
name:"水域附属设施"
}
,
{
symbol:"",
pointType:"point",
belong:"区水利局",
name:"水域护栏"
}
,
{
symbol:"",
pointType:"point",
belong:"区水利局",
name:"防汛墙"
}
,
{
symbol:"",
pointType:"point",
belong:"区水利局",
name:"水域警示牌"
}
,
{
symbol:"",
pointType:"point",
belong:"区水利局",
name:"堤坝破损"
}
,
{
symbol:"",
pointType:"point",
belong:"区水利局",
name:"河道不洁（含沟渠、湖面）"
}
,
{
symbol:"",
pointType:"point",
belong:"区水利局",
name:"水体污染"
}
,
{
symbol:"",
pointType:"point",
belong:"区水利局",
name:"水源地污染"
}
,
{
symbol:"",
pointType:"point",
belong:"区房管局",
name:"挪用/侵占共有财产"
}
,
{
symbol:"",
pointType:"point",
belong:"区房管局",
name:"非法获益"
}
,
{
symbol:"",
pointType:"point",
belong:"区房管局",
name:"非法减免物业费"
}
,
{
symbol:"",
pointType:"point",
belong:"区房管局",
name:"拒交物业费"
}
,
{
symbol:"",
pointType:"point",
belong:"区房管局",
name:"泄漏业主资料"
}
,
{
symbol:"",
pointType:"point",
belong:"区房管局",
name:"其他损害业主利益"
}
,
{
symbol:"",
pointType:"point",
belong:"区房管局",
name:"非法业主大会筹备"
}
,
{
symbol:"",
pointType:"point",
belong:"区房管局",
name:"法律责任"
}
,
{
symbol:"",
pointType:"point",
belong:"区房管局",
name:"干预业主大会"
}
,
{
symbol:"",
pointType:"point",
belong:"区房管局",
name:"物业纠纷"
}
,
{
symbol:"",
pointType:"point",
belong:"区房管局",
name:"公用设施出问题"
}
,
{
symbol:"",
pointType:"point",
belong:"区房管局",
name:"公共绿化维护不及时"
}
,
{
symbol:"",
pointType:"point",
belong:"区房管局",
name:"公共区域不洁"
}
,
{
symbol:"",
pointType:"point",
belong:"区房管局",
name:"小区车辆乱停"
}
,
{
symbol:"",
pointType:"point",
belong:"区房管局",
name:"改动房屋主体结构"
}
,
{
symbol:"",
pointType:"point",
belong:"区房管局",
name:"改动房屋外观"
}
,
{
symbol:"",
pointType:"point",
belong:"区房管局",
name:"损坏/占用公共部位、设施"
}
,
{
symbol:"",
pointType:"point",
belong:"区交通运输局",
name:"公交站亭"
}
,
{
symbol:"",
pointType:"point",
belong:"区交通运输局",
name:"出租车站牌"
}
,
{
symbol:"",
pointType:"point",
belong:"区交通运输局",
name:"道路损坏"
}
,
{
symbol:"",
pointType:"point",
belong:"区交通运输局",
name:"黑车拉客"
}
,
{
symbol:"",
pointType:"point",
belong:"区交通运输局",
name:"交通噪声污染"
}
,
{
symbol:"",
pointType:"point",
belong:"区消防大队",
name:"消防火警"
}
,
{
symbol:"",
pointType:"point",
belong:"区消防大队",
name:"消防设备破损"
}
,
{
symbol:"",
pointType:"point",
belong:"区消防大队",
name:"消防通道占道"
}
,
{
symbol:"",
pointType:"point",
belong:"区消防大队",
name:"消防隐患"
}
,
{
symbol:"",
pointType:"point",
belong:"区消防大队",
name:"消防检查"
}
,
{
symbol:"",
pointType:"point",
belong:"区消防大队",
name:"消防宣传"
}
,
{
symbol:"",
pointType:"point",
belong:"小贝单车",
name:"单车乱停乱放"
}
,
{
symbol:"",
pointType:"point",
belong:"蜜果单车",
name:"单车乱停乱放"
}
,
{
symbol:"",
pointType:"point",
belong:"街道社区",
name:"道路破损",
effect: {
    period: 4,
  },
}
,
{
symbol:"",
pointType:"point",
belong:"街道社区",
name:"安装扶手和道板"
}
,
// {
// symbol:"",
// pointType:"point",
// belong:"街道社区",
// name:""
// }
// ,
{
symbol:"",
name:"区城管局",

pointType:"cloud",
}
,
{
symbol:"",
name:"区交警大队",

pointType:"cloud",
}
,
{
symbol:"",
name:"区供电局",

pointType:"cloud",
}
,
{
symbol:"",
name:"区公安局",

pointType:"cloud",
}
,
{
symbol:"",
name:"区市场监督局",

pointType:"cloud",
}
,
{
symbol:"",
name:"区住建局",

pointType:"cloud",
}
,
{
symbol:"",
name:"区自来水公司",

pointType:"cloud",
}
,
{
symbol:"",
name:"移动公司",

pointType:"cloud",
}
,
{
symbol:"",
name:"电信公司",

pointType:"cloud",
}
,
{
symbol:"",
name:"联通公司",

pointType:"cloud",
}
,
{
symbol:"",
name:"区燃气公司"
,

pointType:"cloud",
}
,
{
symbol:"",
name:"区人社局",

pointType:"cloud",
}
,
{
symbol:"",
name:"区园林局",

pointType:"cloud",
}
,
{
symbol:"",
name:"区林业局",

pointType:"cloud",
}
,
{
symbol:"",
name:"区教体局",

pointType:"cloud",
}
,
{
symbol:"",
name:"区水利局",

pointType:"cloud",
}
,
{
symbol:"",
name:"区房管局",

pointType:"cloud",
}
,
{
symbol:"",
name:"区交通运输局",

pointType:"cloud",
}
,
{
symbol:"",
name:"区消防大队",

pointType:"cloud",
}
,
{
symbol:"",
name:"小贝单车",

pointType:"cloud",
}
,
{
symbol:"",
name:"蜜果单车",

pointType:"cloud",
}
,
{
symbol:"",
name:"街道社区",

pointType:"cloud",
effect: {
    period: 2,
    // symbolSize: [8, 24],
  },
}]

